import React from 'react';
import PropTypes from 'prop-types';
import "./bottom.scss";
import { RouterConfig } from '../../../config';
import { NavLink } from 'react-router-dom';
const data = [
    { text: 'Map4D', link: 'https://map.map4d.vn/', redirect: true },
    { text: 'Chính sách', link: RouterConfig.policy.route },
    { text: 'Điều Khoản', link: RouterConfig.rules.route },
]
const Bottom = props => {
    return (
        <div className='bottom'>
            <div className='distanceEqualToContent' />
            <div className='content'>
                <div className='itemWrap'>
                    {
                        data.map((value, index) => {
                            return <div
                                key={value.text + index}
                                className="item"
                            >
                                {
                                    value?.redirect === true
                                        ? <a href={value.link} >{value.text}</a>
                                        : <NavLink
                                            to={value.link}
                                        >
                                            {value.text}
                                        </NavLink>
                                }
                            </div>
                        })
                    }
                </div>
            </div>
        </div>
    );
};

Bottom.propTypes = {

};

export default Bottom;